import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const Briefcase = ({
  className = '~w-4/5 ~h-4/5',
  fill = COLOR.SECONDARY.LIGHT_400,
  fillDarkMode = COLOR.PRIMARY.DARK_500
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      viewBox='0 0 37 33'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      preserveAspectRatio='xMidYMid meet'>
      <path
        d='M1.5 19.8333C1.5 15.1518 1.5 12.811 2.62353 11.1295C3.10993 10.4016 3.73493 9.77656 4.46287 9.29016C6.14435 8.16663 8.48513 8.16663 13.1667 8.16663H23.1667C27.8482 8.16663 30.189 8.16663 31.8705 9.29016C32.5983 9.77656 33.2233 10.4016 33.7098 11.1295C34.8333 12.811 34.8333 15.1518 34.8333 19.8333C34.8333 24.5148 34.8333 26.8556 33.7098 28.5371C33.2233 29.265 32.5983 29.89 31.8705 30.3765C30.189 31.5 27.8482 31.5 23.1667 31.5H13.1667C8.48513 31.5 6.14435 31.5 4.46287 30.3765C3.73493 29.89 3.10993 29.265 2.62353 28.5371C1.5 26.8556 1.5 24.5148 1.5 19.8333Z'
        fill={fillColor}
        stroke={fillColor}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M24.8333 8.16667C24.8333 5.02397 24.8333 3.45262 23.857 2.47632C22.8807 1.5 21.3093 1.5 18.1667 1.5C15.024 1.5 13.4526 1.5 12.4763 2.47632C11.5 3.45262 11.5 5.02397 11.5 8.16667'
        fill='white'
      />
      <path
        d='M24.8333 8.16667C24.8333 5.02397 24.8333 3.45262 23.857 2.47632C22.8807 1.5 21.3093 1.5 18.1667 1.5C15.024 1.5 13.4526 1.5 12.4763 2.47632C11.5 3.45262 11.5 5.02397 11.5 8.16667'
        stroke={fillColor}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.16675 14.8334L9.25336 15.17C14.9752 16.9434 21.3582 16.9434 27.0801 15.17L28.1667 14.8334M18.1667 16.5V19.8334V16.5Z'
        fill='white'
      />
      <path
        d='M8.16675 14.8334L9.25336 15.17C14.9752 16.9434 21.3582 16.9434 27.0801 15.17L28.1667 14.8334M18.1667 16.5V19.8334'
        stroke='white'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Briefcase;
